/* eslint-disable @typescript-eslint/no-namespace */

import { sharedConsts } from './consts.shared'

declare global {
  namespace NodeJS {
    interface ProcessEnv {
      // cms
      PAYLOAD_APP: 'true'
      PAYLOAD_SEED: 'preview' | 'opsopti' | undefined
      DATABASE_URI: string
      PAYLOAD_SECRET: string
      SMTP_HOST: string
      SMTP_PASS: string
      SMTP_PORT: string
      SMTP_USER: string
      PWA_BASE_URL: string

      // mobile
      // RELATED FILE: ./consts.native.ts
      EXPO_PUBLIC_APP: 'true'
      EXPO_PUBLIC_ENVIRONMENT: 'preview' | 'development' | 'production' | undefined

      // pwa
      // RELATED FILE: packages/shared/src/types/pwa.d.ts
    }
  }
}

export const Consts = (function () {
  if (import.meta && import.meta?.env?.VITE_APP === 'true') {
    const base = {
      isPWA: true,
      isDev: import.meta.env.MODE === 'development',
      isProd: import.meta.env.MODE === 'production',
      isTest: import.meta.env.MODE === 'test',

      env: (window.location.hostname?.split('.')[0] ?? undefined) as 'opsopti' | 'preview' | 'localhost' | undefined,
    }

    const environments = {
      localhost: {
        apiBaseUrl: 'http://localhost:3000/api',
      },
      preview: {
        apiBaseUrl: 'https://preview.api.opsopti.com/api',
      },
      opsopti: {
        apiBaseUrl: 'https://api.opsopti.com/api',
      },
    }

    return {
      ...base,
      ...sharedConsts,
      environments,
    }
  } else if (process.env && process.env.PAYLOAD_APP === 'true') {
    return {
      isCMS: true,
      isDev: process.env.NODE_ENV === 'development',
      isProd: process.env.NODE_ENV === 'production',
      isTest: process.env.NODE_ENV === 'test',

      payloadSecret: process.env.PAYLOAD_SECRET,
      payloadSeed: process.env.PAYLOAD_SEED,
      smtpHost: process.env.SMTP_HOST,
      smtpPass: process.env.SMTP_PASS,
      smtpPort: process.env.SMTP_PORT,
      smtpUser: process.env.SMTP_USER,
      databaseUri: process.env.DATABASE_URI,
      pwaBaseUrl: process.env.PWA_BASE_URL,

      // not used
      environments: undefined,
      env: undefined,
      iosAppLink: undefined,
      androidAppLink: undefined,
    }
  } else {
    return {}
  }
})()
